import React, { Fragment } from "react";
import InputCard from "../../common/InputCard";
import SingleRow from "../../common/SingleRow";

class CardsLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.cardsLayout = [
      // cards
      {
        title: "Input Values",
        items: [
          {
            label: {
              value: "Last Period Processed",
              size: " calc(100% - 70px)"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infLpp"
            },
            size: "40%",
            readOnly: true
          },
          {
            label: {
              value: "Init Deseasonalized Demand",
              size: "calc(100% - 35px)"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infDdi"
            },
            size: "60%",
            readOnly: true
          },
          {
            label: {
              value: "Deseasonalized Demand",
              size: " calc(100% - 70px)",
              fontSize: "97%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infDd"
            },
            size: "40%",
            readOnly: true
          },
          {
            label: {
              value: "Desired Service Level",
              size: "calc(100% - 35px)",
              fontSize: "92%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "infDser"
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: "Pend DSER",
              size: "calc(100% - 35px)"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infPendDser"
            },
            size: "30%",
            readOnly: true
          },

          {
            label: {
              value: "Profile Tag",
              size: " calc(100% - 70px)"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infPtag"
            },
            size: "40%",
            readOnly: true
          },
          {
            label: {
              value: "Order Strategy",
              size: "calc(100% - 35px)"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infOstrat"
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: "Time Supply Minimum",
              size: "calc(100% - 35px)",
              fontSize: "91%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infTmin"
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: "Ptag Year",
              size: " calc(100% - 70px)"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "ptagYear" // ????????????????????????????'
            },
            size: "40%",
            readOnly: true
          },
          {
            label: {
              value: "User Minimum",
              size: "calc(100% - 35px)"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infUserMin"
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: "Fixed Order Quantity",
              size: "calc(100% - 35px)",
              fontSize: "97%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infFoq"
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: "Forecast Type",
              size: "calc(100% - 70px)"
            },
            item: {
              node: "input",
              type: "string",
              filter: "[^oOfFtTuUiIdDeExX]",
              forceCaps: true,
              value: "",
              intemName: "infFt"
            },
            size: "40%"
          },
          {
            label: {
              value: "User Maximum",
              size: "calc(100% - 35px)"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infUserMax"
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: "Coordinated Item Flag",
              size: "calc(100% - 35px)",
              fontSize: "91%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infCoorflg"
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: "Cstock",
              size: "calc(100% - 70px)"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infCstock"
            },
            size: "40%",
            readOnly: true
          },
          {
            label: {
              value: "Lumpy Item Flag",
              size: "calc(100% - 35px)"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infLumpsw"
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: "Item Lead Time",
              size: "calc(100% - 35px)"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infLt"
            },
            size: "30%",
            readOnly: true
          }
        ]
      },
      {
        title: "Recycle Values",
        items: [
          {
            label: {
              size: "50%",
              value: "Demand Filter Reg"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infDflreg"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              size: "50%",
              value: "Fcst Ex Reg"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "infFcStreg"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              size: "50%",
              value: "Tracking Signal Reg"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infTsreg"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              size: "50%",
              value: "Last Period DD"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infLdd"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              size: "50%",
              value: "Dying Item Reg"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infDireg"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              size: "50%",
              value: "Last Period DDI"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infLddi"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              size: "50%",
              value: "Bypass DDU Reg"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infBypreg"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              size: "50%",
              value: "Last Modified"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infModDate"
            },
            readOnly: true,
            size: "50%"
          }
        ]
      },
      {
        items: [
          {
            label: {
              value: "Replenishment IC",
              size: "calc(100% - 42px)"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "infReplenishIc"
            },
            size: "28%"
          },
          {
            label: {
              value: "Pack Rounding 1",
              size: "calc(100% - 35px)"
            },
            item: {
              node: "input",
              type: "string",
              maxLength: 1,
              filter: "[^0-9uUrRnNdD]",
              forceCaps: true,
              value: "",
              intemName: "infPackSw"
            },
            size: "28%"
          },
          {
            label: {
              size: "50%",
              value: "2",
              size: "calc(100% - 35px)"
            },
            item: {
              node: "input",
              type: "string",
              maxLength: 1,
              filter: "[^0-9nNcC]",
              forceCaps: true,
              value: "",
              intemName: "infPackSw2"
            },
            size: "8%"
          },
          {
            label: {
              value: "Tier Rounding 1",
              size: "calc(100% - 42px)"
            },
            item: {
              node: "input",
              type: "number",
              maxLength: 1,
              filter: "[^0-9uUrRnN]",
              forceCaps: true,
              value: "",
              intemName: "infTierSw"
            },
            size: "28%"
          },
          {
            label: {
              size: "50%",
              value: "2",
              size: "calc(100% - 35px)"
            },
            item: {
              node: "input",
              type: "number",
              maxLength: 1,
              filter: "[^0-9nNcC]",
              forceCaps: true,
              value: "",
              intemName: "infTierSw2"
            },
            size: "8%"
          }
        ]
      }
    ];
  }

  componentDidMount() {
    this.setState({ layout: this.cardsLayout });
  }

  formatData = props => {
    if (props) {
      this.cardsLayout.map((card, c) => {
        const inputName = Object.keys(props[c])[0];

        card.items.map((item, i) => {
          if (item.item.intemName === props[c][inputName][i].name) {
            item.item.value =
              props[c][inputName][i].value === undefined ||
              props[c][inputName][i].value === "" ||
              props[c][inputName][i].value === false
                ? ""
                : props[c][inputName][i].value;
            item.item.obj = props[c][inputName][i].obj;
            item.item.span = props[c][inputName][i].span;
            item.label.value = props[c][inputName][i].label;
          }

          return null;
        });
        return null;
      });
    }
    return null;
  };
  getCardsInfo = (info, title) => {
    this.props.setCardsInfo({ [title]: info });
  };
  renderCards = () => {
    this.formatData(this.props.cardsData);
    return (
      <Fragment>
        <div style={{ flex: 1 }}>
          <InputCard
            jsonObj={this.cardsLayout[0]}
            setCardsInfo={this.getCardsInfo}
          />
        </div>
        <div style={{ flex: 1 }}>
          <InputCard
            jsonObj={this.cardsLayout[1]}
            setCardsInfo={this.getCardsInfo}
          />
          <SingleRow
            jsonObj={this.cardsLayout[2]}
            setCardsInfo={this.getCardsInfo}
          />
        </div>
      </Fragment>
    );
  };
  render() {
    return (
      <Fragment>
        <div
          className="cards-container"
          style={{ display: "flex", alignItems: "flex-start" }}
        >
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
export default CardsLayout;
